import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import DashboardServices from "services/Dashboard";

export const statastics = createAsyncThunk(
  "/dashboard/statastics",
  async () => {
    const res = await DashboardServices.statasticsApi();
    return res.data;
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    loading: false,
    redirect: false,
    data: {},
  },
  reducers: {
    clearAuthRedirectState: (state) => {
      state.redirect = false;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(statastics.pending, (state) => {
        state.loading = true;
      })
      .addCase(statastics.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = true;
        state.logIn = true;
        state.data = action.payload.data;
      })
      .addCase(statastics.rejected, (state, action) => {
        state.loading = false;
        state.redirect = false;
        state.logIn = false;
        toast.error(action.error.message);
      });
  },
});

const { reducer } = dashboardSlice;
export default reducer;
